import { render, staticRenderFns } from "./top-nav.vue?vue&type=template&id=45cae019&scoped=true"
import script from "./top-nav.vue?vue&type=script&lang=js"
export * from "./top-nav.vue?vue&type=script&lang=js"
import style0 from "./top-nav.vue?vue&type=style&index=0&id=45cae019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cae019",
  null
  
)

export default component.exports